<template>
	<div class="bg-login">
		<div class="fondo"></div>
		<div class="contenedor">
			<div>
				<div class="card" style="background-color:rgba(255,255,255,0);border:none;">
					<!-- <div class="card-header bg-danger text-white">
						<div class="row">
							<div class="col text-left ">
								<span style="font-size:1.4em;">
									<span class="fa fa-lock mr-2"></span>
									Sesión bloqueada
								</span>
							</div>
							<div class="col text-right">
								<img src="/static/recursos/logo_sip.svg" alt="logo" style="height:40px;">
							</div>
						</div>
					</div> -->
					<div class="card-body text-center">
						<img :src="usuario.avatar" style="width:150px;height:150px;" class="rounded-circle mb-3">
						<h5 style="font-weight: bold;">{{usuario.nombre}} {{usuario.apellidos}}</h5>
					</div>
					<div class="card-body text-center">
						<div class="input-group input-group-lg">
							<input :autocomplete="strNow" type="password" class="form-control" ref="entraPass" v-model="password" placeholder="Contraseña" @keypress.enter="desbloquear()">
							<div class="input-group-append">
								<button class="btn btn-sm btn-primary" @click="desbloquear()">
									<span class="fa fa-unlock"></span>
								</button>
							</div>
						</div>
						<div class="mt-4">
							<button class="btn btn-sm btn-danger" @click="logout()">
								<span class="fa mr-2 fa-sign-out"></span>
								Cerrar sesión
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['usuario'],
	data: function () {
		return {
			password: '',
			strNow: new Date().getTime().toString()
		}
	},
	mounted () {
		window.setTimeout(() => {
			this.$refs.entraPass.focus()
		}, 300)
	},
	methods: {
		desbloquear () {
			this.$store.dispatch('session/doDesbloquear', this.password)
			this.password = ''
		},

		logout () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Cerrar sesión',
				mensaje: `¿Quieres cerrar la sesión del usuario?
				Todo el trabajo que no tuviera guardado se perderá`,
				callback: (acepta) => {
					if (acepta) {
						this.$store.dispatch('session/logout')
					}
				}
			})
		}
	}
}
</script>
<style scoped>
	.bg-login {
		position: fixed;
		display: block;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		overflow: auto;
	}

	.fondo {
		position: fixed;
		display: block;
		top: -10px;
		left: -10px;
		right: -10px;
		bottom: -10px;
		overflow: auto;
		filter: blur(5px);
		background-image: url('./fondo.jpg');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}

	.contenedor {
		position: relative;
		display: block;
		text-align: center;
	}

	.contenedor > div {
		position: relative;
		display: inline-block;
		max-width: 250px;
		width: 90%;
		margin-top: 200px;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/login/bloqueo.vue